import { ArrowLeftIcon } from "../../../../../common/icons/ArrowLeftIcon";

export const IncomingTransitionIcon = ({ fontSize = 12, ...props }) => {
  return (
    <ArrowLeftIcon
      style={{ color: "var(--warning-color)", fontSize }}
      {...props}
    />
  );
};
